<tt-page>
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-list *ngIf="arrowSide === 'L' || arrowSide === 'R'" [ttData]="items" [ttBackStyle]="arrowSide === 'L'" [ttGoto]="false" [ttClickable]="canSelect" (ttClick)="select($event.item)"></tt-list>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="selectoeestate_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <tt-list *ngIf="arrowSide === 'L' || arrowSide === 'R'" [ttData]="items" [ttBackStyle]="arrowSide === 'L'" [ttGoto]="false" [ttClickable]="canSelect" (ttClick)="select($event.item)"></tt-list>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </ng-container>
</tt-page>

<p *ngIf="error" role="alert">{{ error }}</p>
